import { dpReduxAction } from 'shared/infra/redux';
import dialogsManagerActions from 'redux/actions/dialogsManager.actions';
import { subscribeEvent, publishEvent, unsubscribeEvent } from 'shared/libs';

import type { OrderDetailModel, OrderId } from 'shared/domain';
import type { SetReplaceMultipleItemsParams } from 'features/order/substitution-flow/domain';

export function closeOrderDetailDialog() {
  dpReduxAction(dialogsManagerActions.close());
}

export function sfWithoutSuggestionsModalObserver() {
  const EVENT_NAME = 'SF_WITHOUT_SUGGESTIONS_MODAL';
  type Detail = SetReplaceMultipleItemsParams;
  type EventData = CustomEvent<Detail>;
  type ListenerFN = (e: EventData) => void;
  let theListener: ListenerFN = () => undefined;
  return {
    dispatch: (d: Detail) => publishEvent(EVENT_NAME, d),
    remove: () => unsubscribeEvent(EVENT_NAME, theListener),
    add: (lt: ListenerFN) => {
      theListener = lt;
      subscribeEvent(EVENT_NAME, theListener);
    },
  };
}

export function sfCancelOrderModalObserver() {
  const EVENT_NAME = 'SF_CANCEL_ORDER_MODAL';
  type Detail = OrderDetailModel;
  type EventData = CustomEvent<Detail>;
  type ListenerFN = (e: EventData) => void;
  let theListener: ListenerFN = () => undefined;
  return {
    dispatch: (d: Detail) => publishEvent(EVENT_NAME, d),
    remove: () => unsubscribeEvent(EVENT_NAME, theListener),
    add: (lt: ListenerFN) => {
      theListener = lt;
      subscribeEvent(EVENT_NAME, theListener);
    },
  };
}

export function sfOpenFlowExternalObserver() {
  const EVENT_NAME = 'SF_OPEN_FLOW_EXTERNAL';
  type Detail = { orderId: OrderId };
  type EventData = CustomEvent<Detail>;
  type ListenerFN = (e: EventData) => void;
  let theListener: ListenerFN = () => undefined;
  return {
    dispatch: (d: Detail) => publishEvent(EVENT_NAME, d),
    remove: () => unsubscribeEvent(EVENT_NAME, theListener),
    add: (lt: ListenerFN) => {
      theListener = lt;
      subscribeEvent(EVENT_NAME, theListener);
    },
  };
}
